import { render, staticRenderFns } from "./IphoneAgreePopup.vue?vue&type=template&id=4cbfcf14&scoped=true&"
import script from "./IphoneAgreePopup.vue?vue&type=script&lang=js&"
export * from "./IphoneAgreePopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cbfcf14",
  null
  
)

export default component.exports